import React from 'react';
import PropTypes from 'prop-types';

import Button from '@Components/Button';

import './HeatmapLegendButton.scss';

export default function HeatmapLegendButton (props) {
  const { toggleLegend } = props;

  return (
    <Button
      onClick={() => {
        toggleLegend();
      }}
      buttonConfig={{
        className: 'result-toolbar-heatmap-legend-button',
        label: 'Legend',
        type: 'link',
        size: 'tiny',
        e2eName: 'legend',
      }}
      iconConfig={{
        position: 'before',
        name: 'information',
        size: 'sm',
      }}
    />
  );
}
HeatmapLegendButton.defaultProps = {
  toggleLegend: () => {
    Logger.error('something went wrong with toggleLegend prop from angular');
  },
};

HeatmapLegendButton.propTypes = {
  toggleLegend: PropTypes.func,
};
